/**
 * Slack Integration API Client - PRD-3599
 * Frontend API for Slack integration settings and health check
 */

import { apiClient } from './apiClient';

export interface SlackHealthResponse {
  status: string;
  has_bot_token: boolean;
  has_webhook: boolean;
  has_signing_secret: boolean;
  timestamp: string;
}

export interface SlackTestResult {
  success: boolean;
  message: string;
  message_ts?: string;
}

export interface SlackSettings {
  enabled: boolean;
  default_channel: string;
  critical_channel?: string;
  on_call_users: string[];
}

/**
 * Get Slack integration health status
 */
export async function getSlackHealth(): Promise<SlackHealthResponse> {
  const response = await apiClient.get<SlackHealthResponse>('/api/v1/slack/health');
  return response.data;
}

/**
 * Test Slack connection by sending a test message
 */
export async function testSlackConnection(channel?: string): Promise<SlackTestResult> {
  const response = await apiClient.post<SlackTestResult>('/api/v1/slack/test', {
    channel
  });
  return response.data;
}

/**
 * Get current Slack settings for organization
 */
export async function getSlackSettings(): Promise<SlackSettings> {
  const response = await apiClient.get<SlackSettings>('/api/v1/integrations/slack/settings');
  return response.data;
}

/**
 * Update Slack settings for organization
 */
export async function updateSlackSettings(settings: Partial<SlackSettings>): Promise<SlackSettings> {
  const response = await apiClient.put<SlackSettings>('/api/v1/integrations/slack/settings', settings);
  return response.data;
}
